'use strict';

/**
 * Servicio para validar si una agenda o trámite está bloqueado
 * Lee la configuración desde el archivo JSON agendas-bloqueadas.json
 */
angular.module('TurneroApp').service('agendasBloqueadasService', [function () {
    var self = this;
    
    // Cargar la configuración del archivo JSON
    var config;
    try {
        config = require('../../config/agendas-bloqueadas.json');
    } catch (error) {
        config = { agendasBloqueadas: [] };
    }
    
    /**
     * Valida si un trámite específico de una agenda está bloqueado
     * @param {number} idAgenda - ID de la agenda (opcional si se busca solo por trámite)
     * @param {number} idTramite - ID del trámite (opcional)
     * @returns {object|null} - Retorna el objeto de configuración si está bloqueado, null si no lo está
     */
    self.validarAgendaTramite = function (idAgenda, idTramite) {
        // Convertir a números para comparación estricta
        var idAgendaNum = idAgenda ? Number(idAgenda) : null;
        var idTramiteNum = idTramite ? Number(idTramite) : null;
        
        // Si no hay agenda ni trámite, no hay nada que validar
        if (!idAgendaNum && !idTramiteNum) {
            return null;
        }
        
        // Buscar en todas las agendas bloqueadas
        for (var i = 0; i < config.agendasBloqueadas.length; i++) {
            var agendaConfig = config.agendasBloqueadas[i];
            
            // Si tenemos ID de agenda, verificar que coincida
            if (idAgendaNum && agendaConfig.idAgenda !== idAgendaNum) {
                continue; // Esta no es la agenda que buscamos
            }
            
            // Si se bloquea toda la agenda y tenemos el ID de agenda, retornar
            if (agendaConfig.bloquearTodaAgenda === true && idAgendaNum) {
                return agendaConfig;
            }
            
            // Si tenemos ID de trámite, verificar si está en la lista de bloqueados
            if (idTramiteNum && agendaConfig.tramitesBloqueados && agendaConfig.tramitesBloqueados.length > 0) {
                var tramiteBloqueado = agendaConfig.tramitesBloqueados.find(function (tramiteId) {
                    return Number(tramiteId) === idTramiteNum;
                });
                
                if (tramiteBloqueado !== undefined) {
                    // Si tenemos ID de agenda, verificar que coincida
                    if (idAgendaNum && agendaConfig.idAgenda === idAgendaNum) {
                        return agendaConfig; // El trámite está bloqueado para esta agenda
                    }
                    // Si no tenemos ID de agenda pero el trámite está bloqueado, retornar (validación por trámite)
                    if (!idAgendaNum) {
                        return agendaConfig; // El trámite está bloqueado en alguna agenda
                    }
                }
            }
        }
        
        return null; // No está bloqueado
    };
    
    /**
     * Obtiene el mensaje de bloqueo para una agenda/trámite
     * @param {number} idAgenda - ID de la agenda
     * @param {number} idTramite - ID del trámite (opcional)
     * @returns {string|null} - Mensaje de bloqueo o null si no está bloqueado
     */
    self.obtenerMensajeBloqueo = function (idAgenda, idTramite) {
        var configBloqueo = self.validarAgendaTramite(idAgenda, idTramite);
        return configBloqueo ? configBloqueo.mensaje : null;
    };
    
    return self;
}]);




// WEBPACK FOOTER //
// ./app/components/general/agendasBloqueadasService.js